import { useField } from 'react-final-form';
import { FormHelperText } from '@mui/material';

// I copied wrappers and this utils from library https://github.com/lookfirst/mui-rff/tree/master/src
// this is because of mui 4, but library supports only 5.
// I added only showDefaultError

export function ErrorMessage({ showError, meta, formHelperTextProps, helperText }) {
  if (showError) {
    return <FormHelperText {...formHelperTextProps}>{meta.error || meta.submitError}</FormHelperText>;
  }
  if (helperText) {
    return <FormHelperText {...formHelperTextProps}>{helperText}</FormHelperText>;
  }
  return <></>;
}

const config = {
  subscription: {
    error: true,
    submitError: true,
    dirtySinceLastSubmit: true,
    touched: true,
    modified: true
  }
};

export const useFieldForErrors = name => useField(name, config);

export const showDefaultError = ({ meta: { error, touched, submitError } }) => !!(touched && error) || submitError;

export const showErrorOnChange = ({ meta: { error } }) => !!error;
